<template>
  <div class="l-anytime-consultation">
    <div class="l-anytime-consultation__main flex-grow-1">
      <v-btn
        :to="{ path: '/anytime_consultations', query: { tab_id: tabId } }"
        variant="text"
        color="pink"
      >
        一覧へ戻る
      </v-btn>

      <!-- 事前問診 -->
      <anytime-consultation-inquiry
        :class="{ 'mb-4': true, 'pa-0': true, 'px-6': true, 'is-minimum': isSidebarWidthMax && answer.editable }"
      />
      <!--/ 事前問診 -->
      
      <anytime-consultation-assignment-notice
        v-if="isAnotherDoctorAssignedMessageShown"
        message="別の相談員に割り振られた相談です"
      />

      <div class="l-anytime-consultation-answer d-flex flex-column flex-sm-row pa-0 pa-sm-6">
        <div :class="{ 'l-anytime-consultation-answer__left': true, 'w0': isSidebarWidthMax && answer.editable }">
          <!-- サイドバー -->
          <anytime-consultation-addon
            v-if="consultation.userId != null"
            ref="addon"
            :active="answer.editable"
            :user-id="consultation.userId"
            :child-id="consultation.childId"
          />
          <!--/ サイドバー -->
        </div>
        <div class="l-anytime-consultation-answer__right pa-0 mx-sm-2">
          <div class="pa-6 p-answer-form">
            <div>
              <h3 style="color:#D63864; font-size: 1.17em; font-weight: bold;">
                相談員記入欄
              </h3>
              <div class="pt-2">
                <b>回答状況</b>
                <span class="pr-3">： {{ answer.status }}</span>
              </div>
              <div>
                <b>更新日時</b>
                <span class="pr-3">： {{ answer.updatedAt }}</span>
              </div>
              <div>
                <b>記入者</b>
                <span class="pr-3">： {{ answer.doctorName }}</span>
              </div>
              <div>
                <b>送信日時</b>
                <span class="pr-3">： {{ answer.sentAt }}</span>
              </div>
            </div>
            <!-- 回答記入 -->
            <div class="pt-2">
              <v-textarea
                id="input-complaint"
                v-model="answer.complaint"
                variant="outlined"
                hide-details
                name="complaint"
                label="主訴（必須）*"
                rows="2"
                :readonly="!answer.editable"
                required
                @focus="isComplaintFocus = true"
                @blur="isComplaintFocus = false"
              />
              <div class="mb-5">
                <div
                  v-if="answer.editable && isComplaintFocus"
                  style="color: #FB0606;"
                >
                  ■非医療者にもわかる言葉で書いてください。<br>
                  ■個人を特定できる情報は入力しないでください（妊娠週数、月齢など）<br>
                  ※自治体・企業への共有、相談事例として公開することがあるため<br>
                </div>
              </div>
              <midwife-diagnosis
                v-if="consultation.department_type === 'midwife'"
                v-model:karte="answer"
                :active="answer.editable"
              />
              <diagnosis
                v-else
                v-model:karte="answer"
                :department-data="consultation.department_type"
                :active="answer.editable"
              />

              <!-- 回答文エディタ -->
              <template v-if="answer.editable">
                <auto-correction-editor v-model="answer.content" />
              </template>
              <v-textarea
                v-else
                id="input-answer-content"
                v-model="answer.content"
                variant="outlined"
                name="answer-content"
                label="回答（必須）*"
                rows="18"
                readonly
                required
                class="linefeed-label answer-input"
                hide-details
              />

              <!-- カルテ情報 相談内容報告欄 -->
              <div
                v-if="consultation.cooperateWithClinic && answer.forReporting"
                class="cooperated-area"
              >
                <h3
                  style="color: #D63864; font-size: 1.17em; font-weight: bold;"
                  class="text-center"
                >
                  相談内容報告欄
                </h3>
                <div>
                  この相談はかかりつけクリニックに報告する必要があります。<br>
                  事前問診のボックス内（氏名・生年月日など）と以下の3つの欄に入力の内容をクリニックの医師が閲覧します。<br>
                  相談内容報告欄の記載をお願いします。
                </div>
                <v-btn
                  :disabled="!answer.editable"
                  style="background-color: #ec407a; border-color: #ec407a;"
                  @click="copyFromKarteFields()"
                >
                  カルテ内容を反映する
                  <v-icon icon="mdi-content-copy" />
                </v-btn>

                <v-textarea
                  v-model="answer.forReporting.complaint"
                  variant="outlined"
                  hide-details
                  name="complaint_for_reporting"
                  label="報告用主訴（必須）*"
                  required
                  rows="2"
                  :readonly="!answer.editable"
                  :disabled="!answer.editable"
                  class="mb-4"
                />

                <v-textarea
                  v-model="answer.forReporting.diagnosis"
                  variant="outlined"
                  hide-details
                  name="diagnosis_for_reporting"
                  label="報告用暫定診断（必須）*"
                  required
                  rows="2"
                  :readonly="!answer.editable"
                  :disabled="!answer.editable"
                  class="mb-4"
                />

                <v-textarea
                  v-model="answer.forReporting.content"
                  variant="outlined"
                  name="answer-content_for_reporting"
                  label="報告用回答（必須）*"
                  required
                  rows="18"
                  counter
                  :readonly="!answer.editable"
                  :disabled="!answer.editable"
                  class="linefeed-label"
                />
              </div>

              <div
                v-if="hasStaticCheckFindings && answer.editable"
                class="mt-2 pa-3 px-3 d-flex align-center justify-center"
                style="color: #dc2626; background: #fee2e2; border: 1px solid #dc2626; border-radius: 6px; font-size: 13px;"
              >
                <v-icon
                  color="#dc2626"
                  size="18"
                  class="mr-1"
                >
                  mdi-alert-circle-outline
                </v-icon>
                AI作成が疑われる表現が検知されています。修正してください。
              </div>

              <div class="p-btn-area d-flex justify-end flex-wrap">
                <template v-if="answer.editable">
                  <v-tooltip
                    v-model="saveDraftMessageShow"
                    location="top"
                    text="Tooltip"
                    :open-on-click="false"
                    :open-on-hover="false"
                    :close-delay="2000"
                  >
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        class="saveDraftBtn mt-2 mx-0"
                        variant="outlined"
                        color="pink"
                        @click="saveDraft();"
                      >
                        下書き保存
                      </v-btn>
                    </template>
                    <span class="d-flex saveDraftMessage"><v-icon>mdi-check</v-icon>下書きに保存されました</span>
                  </v-tooltip>
                  <div class="d-flex ml-8">
                    <div class="requiredTimeSelect">
                      <v-select
                        v-model="answer.requiredTime"
                        :items="requiredTimeLabels"
                        item-title="text"
                        item-value="value"
                        required
                        density="compact"
                        variant="solo-filled"
                        hide-details="false"
                      />
                    </div>
                    <v-btn
                      v-if="hasStaticCheckFindings"
                      class="sendBtn"
                      style="margin-left: 1px!important;"
                      color="pink"
                      tile
                      @click="openStaticCheckConfirmDialog()"
                    >
                      <v-icon
                        color="#fff"
                        size="18"
                      >
                        mdi-alert-circle-outline
                      </v-icon>
                      警告を無視して送信予約
                    </v-btn>
                    <v-btn
                      v-else
                      class="sendBtn"
                      style="margin-left: 1px!important;"
                      color="pink"
                      tile
                      @click="completeAnswer()"
                    >
                      送信予約
                    </v-btn>
                  </div>
                </template>
                <template v-else-if="answer.sentAt == null && answer.cancelable">
                  <div class="requiredTimeSelect">
                    <v-select
                      v-model="answer.requiredTime"
                      :items="requiredTimeLabels"
                      item-title="text"
                      item-value="value"
                      disabled
                      density="compact"
                      variant="solo-filled"
                      hide-details="false"
                    />
                  </div>
                  <v-btn
                    color="pink lighten-1"
                    style="margin-left: 1px!important;"
                    tile
                    variant="outlined"
                    @click="cancelAnswer()"
                  >
                    送信予約取り消し
                  </v-btn>
                </template>
                <template v-else-if="answer.status === '回答済み'">
                  <div class="requiredTimeSelect">
                    <v-select
                      v-model="answer.requiredTime"
                      :items="requiredTimeLabels"
                      item-title="text"
                      item-value="value"
                      disabled
                      density="compact"
                      variant="solo-filled"
                      hide-details
                    />
                  </div>
                </template>
              </div>
              <anytime-consultation-assignment-notice
                v-if="isUnanswerableByAssignmentMessageShown"
                :font-size="24"
                message="現在は送信予約済み、または別の相談員により編集中のため、内容の編集・回答はできません。"
              />

              <!-- AI添削ボタン -->
              <v-card
                v-if="answer.editable"
                class="mt-2 text-center pa-2"
              >
                <div
                  v-if="isAllCorrectionsResolved"
                  class="d-flex justify-center"
                >
                  <v-icon color="correctionBlue">
                    mdi-check
                  </v-icon>
                  <span color="correctionBlue">添削済み</span>
                </div>
                <div
                  v-else
                >
                  <v-btn
                    color="correctionBlue"
                    size="default"
                    class="px-8"
                    :disabled="hasInProgressCorrections"
                    @click="executeCorrection"
                  >
                    <RobotIcon class="mr-2 svg-white-fill" />
                    AIに添削をお願いする
                  </v-btn>
                  <div style="font-size: 10px">
                    ※AI添削は正確ではない場合があります、ご自身でも内容をご確認の上送信予約をしてください。
                  </div>
                </div>
              </v-card>
            </div>
          </div>
          <!-- お知らせ欄 -->
          <div class="mt-8">
            <p class="text-md-center text-pink">
              ※ 運営からのお知らせ ※
            </p>
            <div class="px-6">
              <p
                style="white-space: pre-wrap; line-height: 25px; word-break: break-all;"
                v-html="referenceInfo.content"
              />
            </div>
          </div>
          <!--/ お知らせ欄 -->
          <!-- 内容クリア -->
          <div
            v-if="!!answer.id && answer.editable"
            class="text-center"
          >
            <v-btn
              color="pink"
              style="text-decoration: underline;"
              variant="text"
              @click="deleteAnswer()"
            >
              このカルテの内容をクリアする
            </v-btn>
          </div>
          <!--/ 内容クリア -->
        </div>
      </div>
    </div>
    <anytime-consultation-sidebar
      v-if="answer.editable"
      ref="sidebar"
      class="flex-grow-0 d-none d-sm-flex"
    />
    <template>
      <!-- Error Message -->
      <v-dialog
        v-model="dialog"
        max-width="500"
      >
        <v-card>
          <v-card-text v-html="$sanitize(newLineCodeToBr(popupMessage))" />
          <v-card-actions>
            <v-btn
              class="ms-auto"
              text="閉じる"
              variant="tonal"
              @click="dialog = false"
            />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- 静的チェック確認モーダル -->
      <static-check-confirm-dialog
        :model-value="staticCheckConfirmDialog"
        @update:model-value="staticCheckConfirmDialog = $event"
        @submit="completeAnswer()"
        @select-sidebar-tab="selectSidebarTabId($event)"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { SIDEBAR_TAB_IDS } from "@/vue/features/anytime-consultation-sidebar/model/sidebarTabIds";
import Diagnosis from "./shared/Diagnosis.vue";
import MidwifeDiagnosis from "./shared/MidwifeDiagnosis.vue";
import AnytimeConsultationInquiry from "./shared/AnytimeConsultationInquiry.vue";
import AnytimeConsultationAddon from "./shared/AnytimeConsultationAddon.vue";
import AnytimeConsultationSidebar from "@/vue/widgets/anytime-consultation-sidebar/ui/AnytimeConsultationSidebar.vue";
import AutoCorrectionEditor from "@/vue/components/shared/anytime_consultation_form/AutoCorrectionEditor.vue";
import RobotIcon from "@/vue/components/images/robotIcon.vue";
import AnytimeConsultationAssignmentNotice from "../widgets/anytime-consultation-assignment-notice";
import StaticCheckConfirmDialog from "@/vue/widgets/anytime-consultation-correction/ui/StaticCheckConfirmDialog.vue";
import { createConsultationPreprocessingRequest } from "@/vue/composables/useConsultationPreprocessingRequest";
import { createConsultationCorrectionsPolling } from "@/vue/composables/useConsultationCorrectionsPolling";
import {
  normalizeAnswerSnapshot,
  isAnswerSnapshotEqual,
} from "@/vue/utils/anytimeConsultationUnsavedChanges";

// 改行ToBr
import commonMixin from "../mixins/chat_log_common.js";

const LEAVE_WARNING_MESSAGE = "未保存の変更があります。離脱すると入力内容が失われる可能性があります。移動しますか？";

export default {
  name: "AnytimeConsultation",
  components: {
    Diagnosis,
    MidwifeDiagnosis,
    AnytimeConsultationInquiry,
    AnytimeConsultationAddon,
    AnytimeConsultationSidebar,
    AutoCorrectionEditor,
    RobotIcon,
    AnytimeConsultationAssignmentNotice,
    StaticCheckConfirmDialog
  },
  mixins: [commonMixin],
  data: () => ({
    tabId: 0,
    isComplaintFocus: false,
    consultationPreprocessingHandlers: null,
    correctionsPollingHandlers: null,
    requiredTimeLabels: [
      { text: "回答の作成時間", value: null },
      { text: "5分未満", value: "less_5" },
      { text: "5分以上10分未満", value: "between_5_10" },
      { text: "10分以上20分未満", value: "between_10_20" },
      { text: "20分以上30分未満", value: "between_20_30" },
      { text: "30分以上40分未満", value: "between_30_40" },
      { text: "40分以上50分未満", value: "between_40_50" },
      { text: "50分以上60分未満", value: "between_50_60" },
      { text: "60分以上", value: "more_60" },
    ],
    // 下書き保存ボタン
    saveDraftMessageShow: false,
    showDraftMessageTimer: null,
    // 注意文言を表示するダイアログ
    dialog: false,
    // 静的チェック確認モーダル
    staticCheckConfirmDialog: false,
    savedSnapshot: null
  }),
  computed: {
    ...mapGetters({
      consultation: "anytimeConsultation",
      answer: "anytimeConsultationAnswer",
      referenceInfo: "anytimeConsultationReferenceInfo",
      popupMessage: "popupMessage",
      isAllCorrectionsResolved: "isAllCorrectionsResolved",
      hasStaticCheckFindings: "hasStaticCheckFindings",
      hasInProgressCorrections: "hasInProgressCorrections",
      isSidebarWidthMax: "isSidebarWidthMax"
    }),
    isAnswerContentFilled: function () {
      return !!this.answer.complaint && (!!this.answer.branch_id || !!this.answer.original_disease) && !!this.answer.content;
    },
    isRequiredTimeFilled: function () {
      return !!this.answer.requiredTime;
    },
    isContainedDraftMessage: function () {
      const content = this.answer?.content ?? "";
      return content.match(/〜についてご心配ですよね。/) || content.match(/〜に関してお答えします。/) || content.match(/（回答本文）/);
    },
    answerContentLength: function () {
      if (this.answer === null || this.answer.content === null || typeof this.answer.content === "undefined") {
        return 0;
      }
      return this.answer.content.length;
    },
    isEnoughContent: function () {
      return this.answerContentLength >= 700;
    },
    isAnswerSet: function () {
      return this.answer.status != null;
    },
    isAnotherDoctorAssignedMessageShown: function () {
      return this.isAnswerSet && !this.answer.assignedForCurrentDoctor && this.answer.sentAt == null;
    },
    isUnanswerableByAssignmentMessageShown: function () {
      return this.isAnotherDoctorAssignedMessageShown && !this.answer.editable;
    },
    currentSnapshot: function () {
      return normalizeAnswerSnapshot(this.answer);
    },
    hasUnsavedChanges: function () {
      if (!this.savedSnapshot) {
        return false;
      }
      return !isAnswerSnapshotEqual(this.savedSnapshot, this.currentSnapshot);
    },
    shouldWarnOnLeave: function () {
      return this.answer.editable === true && this.hasUnsavedChanges;
    },
  },
  watch: {
    "$route.params.id": function (nextId, previousId) {
      if (nextId && nextId !== previousId) {
        this.resetConsultationData(nextId);
      }
    },
    "$route.query.tab_id": function (nextTabId) {
      this.tabId = nextTabId;
    },
  },
  beforeRouteLeave(to, from, next) {
    this.handleRouteLeave(to, from, next);
  },
  beforeRouteUpdate(to, from, next) {
    this.handleRouteLeave(to, from, next);
  },
  created() {
    this.consultationPreprocessingHandlers = createConsultationPreprocessingRequest({
      store: this.$store,
      getConsultation: () => this.consultation,
    });
    this.correctionsPollingHandlers = createConsultationCorrectionsPolling({
      hasInProgressCorrections: () => this.hasInProgressCorrections,
      fetchCorrectionsData: (consultationId) =>
        this.$store.dispatch("fetchCorrectionsData", { consultationId }),
    });

    this.tabId = this.$route.query.tab_id;
    this.resetConsultationData(this.$route.params.id);
  },
  mounted() {
    window.addEventListener("beforeunload", this.onBeforeUnload); // ウィンドウ閉じる前の処理をセット
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUnload); // イベントリスナーを削除
    this.cleanupOnUnmount();
  },
  unmounted() {
    this.clearData();
  },
  methods: {
    ...mapActions([
      "updateUser",
      "updateChild",
      "clearEpdsAnswers",
      "requestCorrections",
      "unsubscribeAnytimeConsultationChannel",
      "selectSidebarTabId",
    ]),
    clearData: function () {
      this.$store.dispatch("clearAnytimeConsultationObjects");
      this.consultationPreprocessingHandlers?.resetRequest();
      this.correctionsPollingHandlers?.stopPolling();
    },
    resetConsultationData: function (consultationId) {
      this.clearEpdsAnswers();
      // 同一コンポーネント再利用（:id 変更）の場合でも、前の相談に紐づく監視/ポーリングが残らないように必ず停止する
      this.clearData();
      return this.loadConsultationData(consultationId);
    },
    loadConsultationData: function (consultationId) {
      const consultationPromise = this.$store.dispatch("findAnytimeConsultation", {
        id: consultationId
      }).then(() => {
        this.consultationPreprocessingHandlers.initializeMonitor();
      });
      const answerPromise = this.$store.dispatch("findAnytimeConsultationAnswer", {
        anytime_consultation_id: consultationId
      }).then(() => {
        this.updateSavedSnapshot();
      });
      const referencePromise = this.$store.dispatch("findAnytimeConsultationReferenceInfo", {
        anytime_consultation_id: consultationId
      });

      return Promise.all([consultationPromise, answerPromise, referencePromise]);
    },
    updateSavedSnapshot: function (answer = this.answer) {
      this.savedSnapshot = normalizeAnswerSnapshot(answer);
    },
    confirmLeave: function () {
      return window.confirm(LEAVE_WARNING_MESSAGE);
    },
    handleRouteLeave: function (to, from, next) {
      // query のみの更新など「同じ相談画面に留まる」場合は未保存警告を出さない
      if (to && from) {
        const isSameRouteName = to.name === from.name;
        const isSameConsultationId = to.params?.id === from.params?.id;
        if (isSameRouteName && isSameConsultationId) {
          next();
          return;
        }
      }

      if (!this.shouldWarnOnLeave) {
        next();
        return;
      }

      const isConfirmed = this.confirmLeave();
      if (isConfirmed) {
        next();
      } else {
        next(false);
      }
    },
    saveDraft: function () {
      return this.$store.dispatch("saveAnytimeConsultationAnswerDraft", {
        anytime_consultation_id: this.consultation.id,
        content: this.answer.content,
        complaint: this.answer.complaint,
        icd10_branch_id: this.answer.branch_id,
        icd10_original_disease: this.answer.original_disease,
        required_time: this.answer.requiredTime
      }).then(() => {
        // 更新成功したら他の要素も保存する
        this.updateUser(this.$refs.addon.user);
        if (this.$refs.addon.child.id) {
          // 子情報が存在するときだけ更新する
          this.updateChild(this.$refs.addon.child);
        }
        this.updateSavedSnapshot();
        clearTimeout(this.showDraftMessageTimer);
        this.saveDraftMessageShow = true;
        this.showDraftMessageTimer = setTimeout(() => {
          this.saveDraftMessageShow = false;
        }, 2000);
      }).catch(() => {
        // 更新失敗
        if (this.popupMessage) {
          this.dialog = true;
        }
      });
    },
    validateAnswerBeforeSubmit() {
      if (!this.isAnswerContentFilled) {
        alert("記入欄に入力漏れがあります");
        return false;
      }
      if (!this.isRequiredTimeFilled) {
        alert("「回答の作成時間」を選択してください");
        return false;
      }
      if (this.isContainedDraftMessage) {
        alert("回答文にテンプレート文章が残っています");
        return false;
      }
      return true;
    },
    completeAnswer: function () {
      if (!this.validateAnswerBeforeSubmit()) return;

      this.$store.dispatch("completeAnytimeConsultationAnswer", {
        anytime_consultation_id: this.consultation.id,
        content: this.answer.content,
        complaint: this.answer.complaint,
        icd10_branch_id: this.answer.branch_id,
        icd10_original_disease: this.answer.original_disease,
        required_time: this.answer.requiredTime
      }).then(() => {
        // 送信予約成功
        this.$store.dispatch("findAnytimeConsultationReferenceInfo", {
          anytime_consultation_id: this.$route.params.id
        });
        this.tabId = this.$route.query.tab_id;
        this.updateUser(this.$refs.addon.user);
        if (this.$refs.addon.child.id) {
          // 子情報が存在するときだけ更新する
          this.updateChild(this.$refs.addon.child);
        }
        this.updateSavedSnapshot();
      }).catch(() => {
        // 更新失敗
        if (this.popupMessage) {
          this.dialog = true;
        }
      });
    },
    cancelAnswer: function () {
      this.$store.dispatch("cancelAnytimeConsultationAnswer", {
        anytime_consultation_id: this.consultation.id,
      }).then(() => {
        this.updateSavedSnapshot();
      }).catch(() => {
        // 更新失敗
        if (this.popupMessage) {
          this.dialog = true;
        }
      });
    },
    deleteAnswer: function () {
      if (confirm("入力された内容を全てクリアします。本当によろしいですか？")) {
        this.$store.dispatch("deleteAnytimeConsultationAnswer", {
          anytime_consultation_id: this.consultation.id
        }).then(() => {
          this.updateSavedSnapshot();
        }).catch(() => {
          // 更新失敗
          // 現状ではメッセージの表示は行っていない
        });
      }
    },
    executeCorrection: function () {
      this.selectSidebarTabId(SIDEBAR_TAB_IDS.AI_CORRECTION);
      this.requestCorrections({
        consultationId: this.$route.params.id,
        cable: this.$cable,
        connectionHandlers: this.correctionsPollingHandlers,
      });
    },
    openStaticCheckConfirmDialog() {
      if (!this.validateAnswerBeforeSubmit()) return;
      this.staticCheckConfirmDialog = true;
    },
    // 未保存での離脱を防止するための処理
    onBeforeUnload(event) {
      if (!event || !this.shouldWarnOnLeave) {
        return;
      }
      event.preventDefault();
      event.returnValue = "";
    },
    // アンマウント時の処理
    cleanupOnUnmount() {
      this.unsubscribeAnytimeConsultationChannel();
    },
  }
};
</script>

<style lang="scss">
.l-anytime-consultation {
  display: flex;
  overflow: auto;
  height: 100vh !important;
  width: 100%;
  font-size: 14px;

  &__main {
    @media (min-width: 600px) {
      max-height: 100vh;
      overflow-y: scroll;
    }
  }
}

.l-anytime-consultation-answer {
  &__left {
    width: 360px;
    transition: width 0.3s 0s ease;

    @media (max-width: 600px) {
      width: 100%;
    }

    &.w0 {
      width: 0px;
    }
  }

  &__right {
    width: 100%;
  }

  .v-text-field--outlined:not(.v-input--is-focused),
  .v-text-field--outlined:not(.v-input--is-focused) .v-input__slot:hover {
    border: 2px solid rgba(0, 0, 0, .54);
  }

  // 入力欄の背景を薄青色にする
  .anytime-consultation-addon {
    .v-input.v-text-field:not(.v-input--disabled) .v-field__field {
      background-color: #e8f2ff !important;
    }
  }

  .diagnosis-form {
    .v-input.v-text-field:not(.v-input--disabled) .v-field__field {
      background-color: #e8f2ff !important;
    }
  }

  .v-input.v-text-field:not(.v-input--readonly) .v-field__field {
    background-color: #e8f2ff !important;
  }

  .parent-special-note .v-input.v-text-field:not(.v-input--disabled) {
    background-color: #e8f2ff !important;
  }

  .child-special-note .v-input.v-text-field:not(.v-input--disabled) {
    background-color: #e8f2ff !important;
  }

  /* vuetify3 対応 入力不可のラベルの透明度を1にする */
  .v-field--disabled {
    --v-disabled-opacity: 1 !important;
  }

  .p-btn-area {
    .requiredTimeSelect {
      max-width: 200px;

      .v-field--active {
        min-height: 36px !important;
        margin-top: 6px;
        border-radius: 0px !important;
        color: #fff !important;
        background-color: #EF5A8D !important;

        .v-field__field {
          background-color: #EF5A8D !important;
        }
      }

      .theme--light.v-icon {
        font-size: 14px;
        color: #fff !important;
      }

      .theme--light.v-label {
        font-size: 14px;
        color: #fff !important;
      }

      .v-select__selection-text {
        font-size: 14px;
        color: #fff;
      }

      .mdi-menu-down::before {
        font-size: 1.17em
      }
    }

    .saveDraftBtn {
      background: #FFFFFF;
      border: 1px solid #EF1A65;

      .v-btn__content .text-black {
        color: #EF1A65;
      }
    }

    .sendBtn {
      .v-btn__content {
        color: #fff;
      }
    }
  }
}

.p-answer-form {
  background-color: #fdeef3;

  .cooperated-area {
    border-top: 1px solid #D63864;
    padding-top: 16px;
    margin-top: 16px;
  }
}

.requiredTimeSelect {
  .v-select {
    height: 36px;
    margin-top: 6px;
  }

  .v-field {
    height: 36px;
    margin-top: 0 !important;
  }

  .v-field__field {
    height: 36px;
  }

  .v-field__input {
    padding-top: 6px !important;
  }
}

.v-theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: rgba(0, 0, 0, .12) !important;
  color: rgba(0, 0, 0, .26) !important;
}

.v-tooltip .v-overlay__content:has(.saveDraftMessage) {
  background: #FFFFFF !important;
  border: 1px solid #EF1A65;
  color: #EF1A65 !important;
}

// SVGアイコン用のスタイル
.svg-correctionBlue-fill {
  fill: #1564bd
}

.svg-white-fill {
  fill: #fff
}
</style>
